<script setup lang="ts">
import { ref } from "vue";
import ColumnLayout from "@/shared/components/ColumnLayout/ColumnLayout.vue";
import ColumnLayoutBox from "@/shared/components/ColumnLayoutBox/ColumnLayoutBox.vue";
import Title from "@/shared/components/Title/Title.vue";
import StatusMessagePage from "@/app/registration-app/shared/components/StatusMessagePage/StatusMessagePage.vue";
import RegistrationForm from "@/app/registration-app/user/new-registration/components/RegistrationForm/RegistrationForm.vue";
import UserAlreadyExistsInfo from "@/app/registration-app/user/new-registration/components/UserAlreadyExistsInfo/UserAlreadyExistsInfo.vue";
import { useRegisterUser } from "./useRegisterUser.composable";

// --- Double Opt-In ---
const doubleOptInInfo = ref(false);
const showDoubleOptInInfo = () => (doubleOptInInfo.value = true);

// --- Error-Handling: User Already Exists ---
const userAlreadyExists = ref(false);
const showUserAlreadyExists = () => {
  userAlreadyExists.value = true;
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

// --- Register User ---
const { isRegisteringUser, onRegisteringUser } = useRegisterUser(
  showDoubleOptInInfo,
  showUserAlreadyExists,
);
</script>

<template>
  <StatusMessagePage
    v-if="doubleOptInInfo"
    :title="$t('registration.user.doubleOptIn.title')"
  >
    <template #text>
      <p>{{ $t("registration.user.doubleOptIn.info") }}</p>
      <p>{{ $t("registration.user.doubleOptIn.info2") }}</p>
    </template>
  </StatusMessagePage>
  <ColumnLayout v-else>
    <template #column1>
      <ColumnLayoutBox>
        <div class="new-registration-view">
          <Title
            size="l"
            :text="$t('registration.user.new.title')"
          />
          <div class="new-registration-view--text">
            <p>
              {{ $t("registration.user.new.text") }}
            </p>
            <UserAlreadyExistsInfo v-if="userAlreadyExists" />
          </div>
          <RegistrationForm
            :is-loading="isRegisteringUser"
            :has-error="userAlreadyExists"
            @register="onRegisteringUser"
          />
        </div>
      </ColumnLayoutBox>
    </template>
  </ColumnLayout>
</template>

<style scoped>
@import "NewRegistrationView.css";
</style>
